// extracted by mini-css-extract-plugin
export var container = "_nf-0";
export var dotAnimation = "_nf-2";
export var dotsLoading = "_nf-1";